var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import 'react-hot-loader';
import { hot } from 'react-hot-loader';
import React from 'react';
import { Grid } from '@mui/material';
import { observer, inject } from 'mobx-react';
import { AppModeEnum } from './models';
import CustomFieldsPanel from './custom-fields/custom-fields-panel';
import CaseTypeCodesEditor from './case-types/case-type-codes-editor';
import CaseTypesEditor from './case-types/case-types-editor';
import ClaimList from './claims/claims-list';
import AddressBookList from './address-book/address-book-list';
import SigningDialog from './signing/signing-dialog';
import WorkflowWizard from './offline-mode/client/workflow-wizard';
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(App.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (_jsx(Grid, __assign({ container: true, direction: "column", className: "flex height-100" }, { children: _jsxs(Grid, __assign({ container: true, direction: "column", item: true, xs: 12, className: "height-100" }, { children: [this.renderApp(), _jsx(SigningDialog, {}, void 0)] }), void 0) }), void 0));
        }
    });
    Object.defineProperty(App.prototype, "renderApp", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            switch ((_a = this.props.rootStore) === null || _a === void 0 ? void 0 : _a.appMode) {
                case AppModeEnum.CaseTypeCodes:
                    return _jsx(CaseTypeCodesEditor, {}, void 0);
                case AppModeEnum.CaseTypes:
                    return _jsx(CaseTypesEditor, {}, void 0);
                case AppModeEnum.CustomFields:
                    return _jsx(CustomFieldsPanel, { isEditMode: false, isCaseTypeSelectorHidden: false, isAddressSelectionEnabled: true }, void 0);
                case AppModeEnum.Claims:
                    return _jsx(ClaimList, {}, void 0);
                case AppModeEnum.AddressBook:
                    return _jsx(AddressBookList, {}, void 0);
                case AppModeEnum.OfflineWorkflow:
                    return _jsx(WorkflowWizard, {}, void 0);
                case AppModeEnum.None:
                default:
                    return null;
            }
        }
    });
    App = __decorate([
        inject('rootStore'),
        inject('fieldsStore'),
        inject('caseTypesStore'),
        inject('signingStore'),
        inject('claimsStore'),
        inject('addressBookStore'),
        inject('workflowStore'),
        inject('organizationGroupStore'),
        observer
    ], App);
    return App;
}(React.Component));
export default hot(module)(App);
